_getCheckoutOrderData